import {gql} from "@apollo/client";

export const GET_SELF = gql`
    query getSelf {
        getSelf{
            id
            displayName
            profileImageUrl
            discordId
            isAdmin
        }
    }
`;

export const HOMEPAGE_VIDEOS = gql`
    query getVideos($limit: Int) {getVideos(limit: $limit){id title thumbnail likeCount viewCount slotMultiplier slotPayout slotGame slotIcon publishedAt}}
`;


export const HOMEPAGE_VIDEOS_GAMBLES = gql`
    query getVideosGambles($limit: Int) {getVideosGambles(limit: $limit){id title thumbnail likeCount viewCount slotMultiplier slotPayout slotGame slotIcon publishedAt}}
`;
export const HOMEPAGE_VIDEOS_CSGO = gql`
    query getVideosCsgo($limit: Int) {getVideosCsgo(limit: $limit){id title thumbnail likeCount viewCount slotMultiplier slotPayout slotGame slotIcon publishedAt}}
`;

export const HOMEPAGE_LEADERBOARD = gql`
    query getLeaderboardRoobet($month: Int) {getLeaderboardRoobet(month: $month){PlayerName PlayerId PlayerImage WageredAmount }}
`;
export const HOMEPAGE_LEADERBOARD_SHUFFLE = gql`
    query getLeaderboardShuffle($month: Int) {getLeaderboardShuffle(month: $month){PlayerName PlayerId PlayerImage WageredAmount }}
`;
export const HOMEPAGE_LEADERBOARD_STAKE = gql`
    query getLeaderboardStake($month: Int) {getLeaderboardStake(month: $month){PlayerName PlayerId WageredAmount }}
`;
export const HOMEPAGE_LEADERBOARD_BIG = gql`
    query getLeaderboardBig($month: Int) {getLeaderboardBig(month: $month){PlayerName PlayerId PlayerImage WageredAmount }}
`;
export const HOMEPAGE_LEADERBOARD_LUXDROP = gql`
    query getLeaderboardLuxdrop($month: Int) {getLeaderboardLuxdrop(month: $month){ PlayerName PlayerId PlayerImage WageredAmount }}
`;
export const HOMEPAGE_LEADERBOARD_HYPEDROP = gql`
    query getLeaderboardHypedrop($month: Int) {getLeaderboardHypedrop(month: $month){ PlayerName PlayerId PlayerImage WageredAmount }}
`;
export const HOMEPAGE_LEADERBOARD_CASES = gql`
    query getLeaderboardCases($month: Int) {getLeaderboardCases(month: $month){ PlayerName PlayerId PlayerImage WageredAmount }}
`;
export const HOMEPAGE_LEADERBOARDPRIZES = gql`
    query getLeaderboardPrizes {getLeaderboardPrizes{ Position Reward }}
`;
export const HOMEPAGE_LEADERBOARDPRIZES_STAKE = gql`
    query getLeaderboardPrizesStake {getLeaderboardPrizesStake{ Position Reward }}
`;
export const HOMEPAGE_LEADERBOARDPRIZES_CSGOBIG = gql`
    query getLeaderboardPrizesBig {getLeaderboardPrizesBig{ Position Reward }}
`;
export const HOMEPAGE_LEADERBOARDPRIZES_BIG = gql`
    query getLeaderboardPrizesBig {getLeaderboardPrizesBig{ Position Reward }}
`;

export const HOMEPAGE_LEADERBOARDPRIZES_LUXDROP = gql`
    query getLeaderboardPrizesLuxdrop {getLeaderboardPrizesLuxdrop{ Position Reward }}
`;
export const HOMEPAGE_LEADERBOARDPRIZES_HYPEDROP = gql`
    query getLeaderboardPrizesHypedrop {getLeaderboardPrizesHypedrop{ Position Reward }}
`;
export const HOMEPAGE_LEADERBOARDPRIZES_CASES = gql`
    query getLeaderboardPrizesCases {getLeaderboardPrizesCases{ Position Reward }}
`;

export const HOMEPAGE_LEADERBOARD_CLASH = gql`
    query getLeaderboardClashes($month: Int) {getLeaderboardClashes(month: $month){PlayerName PlayerId PlayerImage WageredAmount }}
`;
export const HOMEPAGE_LEADERBOARD_ROLL = gql`
    query getLeaderboardRoll($month: Int) {getLeaderboardRoll(month: $month){PlayerName PlayerId PlayerImage WageredAmount Deposited }}
`;
export const HOMEPAGE_LEADERBOARDPRIZES_CLASH = gql`
    query getLeaderboardPrizesClashes {getLeaderboardPrizesClashes{ Position Reward }}
`;
export const HOMEPAGE_LEADERBOARDPRIZES_ROLL = gql`
    query getLeaderboardPrizesRoll {getLeaderboardPrizesRoll{ Position Reward }}
`;

export const HOMEPAGE_LEADERBOARD_PACKDRAW = gql`
    query getLeaderboardPackdraws($month: Int) {getLeaderboardPackdraws(month: $month){PlayerName PlayerId PlayerImage WageredAmount }}
`;
export const HOMEPAGE_LEADERBOARDPRIZES_PACKDRAW = gql`
    query getLeaderboardPrizesPackdraw {getLeaderboardPrizesPackdraw{ Position Reward }}
`;


export const ADMIN_GET_ROLL_MONTHS = gql`
    query getLeaderboardRollMonths {getLeaderboardRollMonths{ Month Year }}
`;
export const ADMIN_GET_HD_SLOTH_MONTHS = gql`
    query getLeaderboardHypedropSlothMonths {getLeaderboardHypedropSlothMonths{ Month Year }}
`;
export const ADMIN_GET_HD_KAZLIC_MONTHS = gql`
    query getLeaderboardHypedropMonths {getLeaderboardHypedropMonths{ Month Year }}
`;

export const ADMIN_GET_ROLL_KAZLIC_MONTHS = gql`
    query getLeaderboardRollKazlicMonths {getLeaderboardRollKazlicMonths{ Month Year }}
`;

export const ADMIN_GET_ROLL_LEADERBOARD = gql`
    query adminGetLeaderboardRoll($month: Int, $year: Int) {adminGetLeaderboardRoll(month: $month, year: $year){ PlayerName PlayerId PlayerImage WageredAmount Deposited }}
`;
export const ADMIN_GET_HD_SLOTH_LEADERBOARD = gql`
    query adminGetLeaderboardHypedropSloth($month: Int, $year: Int) {adminGetLeaderboardHypedropSloth(month: $month, year: $year){ PlayerName PlayerId PlayerImage WageredAmount Deposited }}
`;
export const ADMIN_GET_HD_KAZLIC_LEADERBOARD = gql`
    query adminGetLeaderboardHypedrop($month: Int, $year: Int) {adminGetLeaderboardHypedrop(month: $month, year: $year){ PlayerName PlayerId PlayerImage WageredAmount Deposited }}
`;
export const ADMIN_GET_ROLL_KAZLIC_LEADERBOARD = gql`
    query adminGetLeaderboardRollKazlic($month: Int, $year: Int) {adminGetLeaderboardRollKazlic(month: $month, year: $year){ PlayerName PlayerId PlayerImage WageredAmount Deposited }}
`;

export const ADMIN_GET_ROOBET_MONTHS = gql`
    query getLeaderboardRoobetMonths {getLeaderboardRoobetMonths{ Month Year }}
`;
export const ADMIN_GET_ROOBET_LEADERBOARD = gql`
    query adminGetLeaderboardRoobet($month: Int, $year: Int) {adminGetLeaderboardRoobet(month: $month, year: $year){ PlayerName PlayerId PlayerImage WageredAmount }}
`;

export const ADMIN_GET_PACKDRAW_MONTHS = gql`
    query getLeaderboardPackdrawMonths {getLeaderboardPackdrawMonths{ Month Year }}
`;
export const ADMIN_GET_PACKDRAW_LEADERBOARD = gql`
    query adminGetLeaderboardPackdraws($month: Int, $year: Int) {adminGetLeaderboardPackdraws(month: $month, year: $year){ PlayerName PlayerId PlayerImage WageredAmount }}
`;

export const ADMIN_GET_CLASH_MONTHS = gql`
    query getLeaderboardClashMonths {getLeaderboardClashMonths{ Month Year }}
`;
export const ADMIN_GET_CLASH_LEADERBOARD = gql`
    query adminGetLeaderboardClashes($month: Int, $year: Int) {adminGetLeaderboardClashes(month: $month, year: $year){ PlayerName PlayerId PlayerImage WageredAmount }}
`;

export const ADMIN_GET_SHUFFLE_MONTHS = gql`
    query getLeaderboardShuffleMonths {getLeaderboardShuffleMonths{ Month Year }}
`;
export const ADMIN_GET_LUXDROP_MONTHS = gql`
    query getLeaderboardLuxdropMonths {getLeaderboardLuxdropMonths{ Month Year }}
`;
export const ADMIN_GET_STAKE_MONTHS = gql`
    query getLeaderboardStakeMonths {getLeaderboardStakeMonths{ Month Year }}
`;
export const ADMIN_GET_BIG_MONTHS = gql`
    query getLeaderboardBigMonths {getLeaderboardBigMonths{ Month Year }}
`;
export const ADMIN_GET_SHUFFLE_LEADERBOARD = gql`
    query adminGetLeaderboardShuffle($month: Int, $year: Int) {adminGetLeaderboardShuffle(month: $month, year: $year){ PlayerName PlayerId PlayerImage WageredAmount }}
`;
export const ADMIN_GET_LUXDROP_LEADERBOARD = gql`
    query adminGetLeaderboardLuxdrop($month: Int, $year: Int) {adminGetLeaderboardLuxdrop(month: $month, year: $year){ PlayerName PlayerId PlayerImage WageredAmount }}
`;
export const ADMIN_GET_STAKE_LEADERBOARD = gql`
    query adminGetLeaderboardStake($month: Int, $year: Int) {adminGetLeaderboardStake(month: $month, year: $year){ PlayerName PlayerId PlayerImage WageredAmount }}
`;
export const ADMIN_GET_BIG_LEADERBOARD = gql`
    query adminGetLeaderboardBig($month: Int, $year: Int) {adminGetLeaderboardBig(month: $month, year: $year){ PlayerName PlayerId PlayerImage WageredAmount }}
`;

export const HOMEPAGE_LEADERBOARD_ADMIN = gql`
    query adminGetLeaderboardShuffle($month: Int) {adminGetLeaderboardShuffle(month: $month){PlayerName PlayerId WageredAmount}}
`;

export const HOMEPAGE_LEADERBOARD_RAINGG = gql`
  query getLeaderboardRaingg($month: Int) {
    getLeaderboardRaingg(month: $month) {
      PlayerName
      PlayerId
      PlayerImage
      WageredAmount
      Prize
      Position
      StartsAt
      EndsAt
    }
  }
`;

// Admin helpers
export const ADMIN_GET_RAINGG_MONTHS = gql`
  query getLeaderboardRainggMonths {
    getLeaderboardRainggMonths { Month Year }
  }
`;

export const ADMIN_GET_RAINGG_LEADERBOARD = gql`
  query adminGetLeaderboardRaingg($month: Int, $year: Int) {
    adminGetLeaderboardRaingg(month: $month, year: $year) {
      PlayerName
      PlayerId
      PlayerImage
      WageredAmount
      Prize
      Position
    }
  }
`;